






































































































































import Vue from 'vue';
import { RequestSession } from '@/interfaces/requestSession';
import { Donation } from '@/interfaces/donation/donation';
import { Snackbar } from '@/interfaces/presentation/snackbar';
import { Dialog } from '@/interfaces/presentation/dialog';
import { DonationStep } from '@/interfaces/donationStep';

import DonationTypeView from '@/views/DonationTypeView.vue';
import InformationView from '@/views/InformationView.vue';
import CaseView from '@/views/CaseView.vue';
import CertificateDetailsView from '@/views/CertificateDetails.vue';
import SummaryView from '@/views/SummaryView.vue';
import PaymentView from '@/views/PaymentView.vue';
import PaylinkPaymentView from '@/views/PaylinkPaymentView.vue';
import SuccessView from '@/views/SuccessView.vue';

import LogoFooter from '@/components/global/LogoFooter.vue';
import StepperFlowMixin from '@/mixins/donationStepperFlowMixin';
import ProgressIndicatorComponent from '../progressIndicator/ProgressIndicatorComponent.vue';
import DonationDetailsAndPaymentDeliveryView
  from '@/views/DonationDetailsAndPaymentDeliveryView.vue';

export default Vue.extend({
  components: {
    DonationDetailsAndPaymentDeliveryView,
    LogoFooter,
    DonationTypeView,
    InformationView,
    CaseView,
    SummaryView,
    PaymentView,
    PaylinkPaymentView,
    SuccessView,
    CertificateDetailsView,
    ProgressIndicatorComponent,
  },
  mixins: [StepperFlowMixin],
  props: {
    multipleDonationTypes: {
      type: Boolean,
      default: false,
    },
    requestHasExternalAgent: {
      type: Boolean,
      default: false,
    },
    requestHasOnlyOneCase: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
    },
    definedStep: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      availableSteps: [] as Array<DonationStep>,
    };
  },
  computed: {
    requestSession(): RequestSession {
      return this.$store.state.requestSession;
    },
    donation(): Donation {
      return this.$store.state.donation;
    },
    snackbar(): Snackbar {
      return this.$store.state.snackbar;
    },
    currentStep(): DonationStep {
      return this.getDonationStep(this.$store.state.currentStep);
    },
    dialog(): Dialog {
      return this.$store.state.dialog;
    },
  },
  created() {
    this.availableSteps = this.getInitialSteps();
  },
  async mounted() {
    if (!!this.definedStep) {
      this.setStep(this.definedStep);
    }
  },
});
